import {Button, Icon, clx} from '@hm/fundamental'
import {mdiDeleteOutline, mdiPlus} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {StaticPartEditModesEnum} from '@refra/modules/refra-static-parts/enums'
import {useEditReplacement} from '@refra/modules/refra-static-parts/providers'

export const DrawingControls = () => {
  const {t} = useTranslation()
  const {editMode, setEditMode} = useEditReplacement()

  return (
    <div className="flex gap-1 rounded-lg border border-gray-100 bg-white p-1 shadow-md">
      <Button
        variant={editMode === StaticPartEditModesEnum.ADD ? 'tertiary' : 'secondary'}
        onClick={() => setEditMode(StaticPartEditModesEnum.ADD)}
        className={clx(
          'flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-semibold transition-all border-none',
          editMode === StaticPartEditModesEnum.ADD
            ? 'bg-blue-50 text-blue-600'
            : 'text-gray-500 hover:bg-gray-50'
        )}
      >
        <Icon
          path={mdiPlus}
          customSize={0.8}
          className={clx(
            editMode === StaticPartEditModesEnum.ADD ? 'text-blue-600' : 'text-gray-600'
          )}
        />
        {t('staticParts.editReplacement.mode.add')}
      </Button>
      <Button
        variant={editMode === StaticPartEditModesEnum.REMOVE ? 'tertiary' : 'secondary'}
        onClick={() => setEditMode(StaticPartEditModesEnum.REMOVE)}
        className={clx(
          'flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-semibold transition-all border-none',
          editMode === StaticPartEditModesEnum.REMOVE
            ? 'bg-blue-50 text-blue-600'
            : 'text-gray-500 hover:bg-gray-50'
        )}
      >
        <Icon
          path={mdiDeleteOutline}
          customSize={0.8}
          className={clx(
            editMode === StaticPartEditModesEnum.REMOVE ? 'text-blue-600' : 'text-gray-600'
          )}
        />
        {t('staticParts.editReplacement.mode.remove')}
      </Button>
    </div>
  )
}
